/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".select-multiple-header{display:block;margin-bottom:-14px}  .synced-row{float:right}  .ui-tabview{height:100%}  .ui-tabview-panels{height:760px}"];
export { styles as styles };
